import { render } from "./ModalPayment.vue?vue&type=template&id=3df5f8ea"
import script from "./ModalPayment.vue?vue&type=script&lang=js"
export * from "./ModalPayment.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__